import { Link } from "react-router-dom";

const footerLinks = [
  {
    title: "快速导航",
    items: [
      { label: "首页", path: "/" },
      { label: "使用指南", path: "/category/usage-guide" },
      { label: "最新动态", path: "/category/latest-news" },
      { label: "常见问题", path: "/category/faq-help" },
    ],
  },
  {
    title: "帮助支持",
    items: [
      { label: "安全指南", path: "/category/security-tips" },
      { label: "功能介绍", path: "/category/feature-intro" },
      { label: "关于我们", path: "/about" },
      { label: "联系我们", path: "/about#contact" },
    ],
  },
  {
    title: "热门文章",
    items: [
      { label: "如何正确访问官网入口", path: "/article/how-to-access-17c-official" },
      { label: "账号安全防护指南", path: "/article/account-security-protection" },
      { label: "登录常见问题解决", path: "/article/common-login-problems" },
      { label: "2026年全新功能介绍", path: "/article/17c-new-features-2026" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 font-heading text-xl font-bold text-white mb-4 cursor-pointer">
              <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center text-sm font-bold text-white">
                17
              </span>
              17c一起草
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              17c一起草官网入口官方直达通道，提供最新地址、安全登录通道及完整功能体验。收藏本页永久有效，告别失效链接烦恼。
            </p>
          </div>

          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="font-semibold text-white mb-4 text-sm">{col.title}</h4>
              <ul className="flex flex-col gap-2.5">
                {col.items.map((item) => (
                  <li key={item.label}>
                    <Link
                      to={item.path}
                      className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 17c一起草官网入口. 本站为官方认证导航平台，所有入口链接均经过官方授权。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-500">友情链接：</span>
            <a href="#" rel="nofollow" className="text-xs text-foreground-400 hover:text-white transition-colors">一起草官网直达</a>
            <a href="#" rel="nofollow" className="text-xs text-foreground-400 hover:text-white transition-colors">17c官方入口地址</a>
            <a href="#" rel="nofollow" className="text-xs text-foreground-400 hover:text-white transition-colors">一起草最新官网链接</a>
          </div>
        </div>
      </div>
    </footer>
  );
}